var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalBeauty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 360",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgCB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a0b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3b1c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5b2333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentCB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9a8d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fcd34d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbleUser",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9a8d4",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec4899",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubbleBot",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glowCB",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 360,
    fill: "url(#bgCB)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    stroke: "url(#accentCB)",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 60,
    r: 80
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 60,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 320,
    r: 70
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 320,
    r: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 36)",
    filter: "url(#glowCB)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 20,
    fill: "none",
    stroke: "url(#accentCB)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10 L24 18 L32 18 L26 23 L28 31 L22 26 L16 31 L18 23 L12 18 L20 18 Z",
    fill: "url(#accentCB)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 50)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#ffffff",
    fontSize: 22,
    fontWeight: 700
  }, "Clinical Beauty"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fill: "#fcd34d",
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 1
  }, "AGENTIC AI ASSISTANT"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 110)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 290,
    height: 38,
    rx: 19,
    fill: "url(#bubbleUser)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 24,
    fill: "#3b0a1f",
    fontSize: 13,
    fontWeight: 600
  }, "Hola, \xBFtienes hueco ma\xF1ana 4pm?"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 50,
    width: 320,
    height: 38,
    rx: 19,
    fill: "url(#bubbleBot)",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 74,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 500
  }, "S\xED \u2728 te agend\xE9 limpieza facial \u2014 4:00pm."), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 180,
    height: 38,
    rx: 19,
    fill: "url(#bubbleUser)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 124,
    fill: "#3b0a1f",
    fontSize: 13,
    fontWeight: 600
  }, "Perfecto, gracias \uD83D\uDC95"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 150,
    width: 280,
    height: 38,
    rx: 19,
    fill: "url(#bubbleBot)",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 174,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 500
  }, "Te env\xEDo recordatorio por Gmail \uD83D\uDCE9"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 196)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fcd34d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 0,
    r: 3,
    fill: "#fcd34d",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 3,
    fill: "#fcd34d",
    opacity: 0.4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400 110)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif",
    fontSize: 11,
    fill: "#fde68a",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#fcd34d",
    fontSize: 11,
    letterSpacing: 1.5
  }, "STACK"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 26,
    rx: 13,
    fill: "#ffffff14",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 5,
    fill: "#ea4b71"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 17,
    fill: "#ffffff"
  }, "N8N \xB7 Multi-agent")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 26,
    rx: 13,
    fill: "#ffffff14",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 5,
    fill: "#a78bfa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 17,
    fill: "#ffffff"
  }, "MCP Protocol")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 26,
    rx: 13,
    fill: "#ffffff14",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 5,
    fill: "#22d3ee"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 17,
    fill: "#ffffff"
  }, "RAG \xB7 Clinical KB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 26,
    rx: 13,
    fill: "#ffffff14",
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 5,
    fill: "#34d399"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 17,
    fill: "#ffffff"
  }, "Calendar + Gmail")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 308)",
    fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 528,
    height: 36,
    rx: 18,
    fill: "url(#accentCB)",
    opacity: 0.15,
    stroke: "url(#accentCB)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 23,
    fill: "#fcd34d",
    fontSize: 13,
    fontWeight: 700
  }, "\u26A1 Saved 6 hours/week of manual client communication"), /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 23,
    fill: "#ffffff",
    fontSize: 11,
    fontWeight: 500,
    opacity: 0.85
  }, "PRODUCTION \xB7 LIVE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalBeauty);
export default __webpack_public_path__ + "static/media/clinical-beauty.e0afd2fd91130a9af278bbc897220fa2.svg";
export { ForwardRef as ReactComponent };